import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function PricingSection() {
  return <section className="bg-[#F5F5F5] py-16 px-4 md:py-20" data-id="element-223">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-225">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#00A86B]" data-id="element-226"></div>

          <div className="inline-block bg-[#FFF3D6] text-yellow-800 font-heading font-bold text-sm px-4 py-1.5 rounded-full mb-4" data-id="element-227">
            🔥 OFERTA SOLO POR HOY
          </div>

          <div className="mb-1" data-id="element-228">
            <span className="text-red-500 line-through text-2xl font-heading font-bold" data-id="element-229">
              $35.000
            </span>
          </div>

          <div className="mb-2" data-id="element-230">
            <PriceDisplay amount={14500} className="font-heading font-bold text-[52px] text-[#00A86B] leading-none" data-id="element-231" />
          </div>

          <p className="text-gray-500 italic text-sm md:text-base mb-8" data-id="element-232">
            Menos que una rotisería para dos. Y lo usás todos los días.
          </p>

          <div className="w-full max-w-md mx-auto mb-6" data-id="element-233">
            <CTAButton data-id="element-234">QUIERO LAS RECETAS AHORA →</CTAButton>
          </div>

          {/* Bloque de pagos */}
          <div className="border-t border-gray-100 pt-5" data-id="element-235">
            <div className="flex justify-center items-center gap-4 mb-3" data-id="element-236">
              {/* Logo Mercado Pago */}
              <svg height="28" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-237">
                <text x="0" y="28" fontFamily="Arial" fontWeight="bold" fontSize="14" fill="#009EE3" data-id="element-238">mercado</text>
                <text x="0" y="40" fontFamily="Arial" fontWeight="bold" fontSize="14" fill="#009EE3" data-id="element-239">pago</text>
              </svg>

              {/* Mastercard */}
              <svg width="44" height="28" viewBox="0 0 44 28" xmlns="http://www.w3.org/2000/svg" data-id="element-240">
                <rect width="44" height="28" rx="4" fill="white" data-id="element-241" />
                <circle cx="17" cy="14" r="10" fill="#EB001B" data-id="element-242" />
                <circle cx="27" cy="14" r="10" fill="#F79E1B" data-id="element-243" />
                <path d="M22 6.8a10 10 0 0 1 0 14.4A10 10 0 0 1 22 6.8z" fill="#FF5F00" data-id="element-244" />
              </svg>

              {/* Visa */}
              <svg width="44" height="28" viewBox="0 0 44 28" xmlns="http://www.w3.org/2000/svg" data-id="element-245">
                <rect width="44" height="28" rx="4" fill="white" stroke="#e5e7eb" strokeWidth="1" data-id="element-246" />
                <text x="6" y="20" fontFamily="Arial" fontWeight="bold" fontSize="14" fill="#1A1F71" data-id="element-247">VISA</text>
              </svg>
            </div>

            <p className="text-gray-400 text-xs mb-4 flex items-center justify-center gap-1" data-id="element-248">
              🔒 Plataforma segura. Aboná con Mercado Pago.
            </p>

            <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6 text-sm text-gray-600 font-medium" data-id="element-249">
              <div className="flex items-center gap-1.5" data-id="element-250">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-251"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-252" /></svg>
                <span data-id="element-253">Compra 100% segura</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-254">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-255"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-256" /></svg>
                <span data-id="element-257">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-258">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-259"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-260" /></svg>
                <span data-id="element-261">Descarga digital</span>
              </div>
            </div>
          </div>

        </motion.div>
      </div>
    </section>;
}